/**
 * radio 组件
 * 选中值为 true
 */
import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";

@Component({
  selector: "kreform-field-ion-radio",
  template: `
    <ng-container>
      <ion-radio-group
        [formControl]="formControl"
        [ionKreFormAttributes]="field"
      >
        <ion-item>
          <ion-label [position]="to.labelPosition" class="">
            <span *ngIf="to.required" class="required-icon">*</span
            >{{ to.label }} </ion-label
          ><ion-radio
            slot="end"
            [disabled]="!editor"
            [value]="to.value"
            mode="md"
          ></ion-radio
        ></ion-item>
      </ion-radio-group>
    </ng-container>
  `,
})
export class KreFormFieldIonRadio extends FieldType {}
